<template>
  <FullCalendar :options="calendarOptions" />
</template>

<script>$('#born-date').datetimepicker({
  format: 'DD-MM-YYYY',
});
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'

export default {
  name: "EventsCalendar",
  components: {
    FullCalendar // make the <FullCalendar> tag available
  },
  data() {
    return {
      calendarOptions: {
        headerToolbar: {
          start: '',
          center: '',
          end: ''
        },
        initialDate: `${this.year}-${this.month}-01`,
        initialView: 'dayGridMonth',
        plugins: [ dayGridPlugin , interactionPlugin ],
        events: this.events,
        eventContent: function(element) {
          return {html: `<a class="calendar-link" href="${element.event.url}"><img src="${element.event.extendedProps.image_url}" width="100%"></a>`}
        },
      }
    }
  },
  props: {
    events: Array,
    month: String,
    year: String,
  }
}
</script>

<style scoped>

</style>
